import React, { useState } from 'react';

interface AppointmentService {
  title: string;
  slogan?: string;
  description?: string;
  duration: string;
  price?: string;
}

const services: AppointmentService[] = [
  {
    title: 'Göç Rehberliği Ön Görüşmesi',
    slogan: 'Göç rehberlik hizmetimiz ile ilgili bilgi alabilmeniz için tanışma görüşmesi.',
    description:
      "Almanya yolculuğunuzun başlangıcındaki belirsizlikleri ortadan kaldırmak için tasarlanmış, kısa ve etkili bir tanışma buluşmasıdır. Sizinle bir araya gelerek hikayenizi dinliyor, temel hedeflerinizi anlıyor ve sürecin işleyişine dair merak ettiğiniz konuları kendi tecrübelerimiz ve hazırlık süreci odaklı pratik bilgiler ışığında değerlendiriyoruz.",
    duration: '15 dk.',
    price: '10 €',
  },
  {
    title: 'Banka Hesap Açılışı',
    slogan: 'Banka hesabı rehberlik hizmetimiz ile ilgili bilgi alabilmeniz için tanışma görüşmesi.',
    description:
      "Almanya'da banka hesabı açma sürecinde sunduğumuz bilgilendirme hizmetini tanıtmak ve sizin durumunuzu anlamak için ayrılmış kısa bir görüşmedir.",
    duration: '5 dk.',
  },
  {
    title: 'Sağlık Sigorta Başvurusu',
    slogan: 'Sağlık sigortası rehberlik hizmetimiz ile ilgili bilgi alabilmeniz için tanışma görüşmesi.',
    description:
      "Almanya'da sağlık sigortası başvuru sürecinde sunduğumuz bilgilendirme hizmetini tanıtmak ve sizin durumunuzu anlamak için ayrılmış kısa bir görüşmedir.",
    duration: '5 dk.',
  },
  {
    title: 'Vize İşlemleri',
    slogan: 'Vize rehberlik hizmetimiz ile ilgili bilgi alabilmeniz için tanışma görüşmesi.',
    description:
      "Almanya'ya yönelik Mavi Kart, Çalışma, İş Arama, Aile Birleşimi, Öğrenci ve Fırsat Kartı vize başvurularında sunduğumuz süreç rehberlik hizmetini tanıtmak ve sizin durumunuzu anlamak için ayrılmış kısa bir görüşmedir.",
    duration: '10 dk.',
  },
  {
    title: 'Oturum İşlemleri',
    slogan: 'Oturum rehberlik hizmetimiz ile ilgili bilgi alabilmeniz için tanışma görüşmesi.',
    description:
      "Almanya'da oturum başvurusu, uzatma veya farklı oturum türleri arası geçiş süreçlerinde sunduğumuz süreç rehberlik hizmetini tanıtmak için tasarlanmış kısa bir görüşmedir. Mevcut oturum durumunuzu dinliyor ve hazırlık desteğimizin ihtiyaçlarınızı nasıl karşılayabileceğini birlikte değerlendiriyoruz.",
    duration: '10 dk.',
  },
  {
    title: 'Daire Kiralama',
    slogan: 'Daire kiralama rehberlik hizmetimiz ile ilgili bilgi alabilmeniz için tanışma görüşmesi.',
    description:
      "Almanya'da eşyalı veya boş daire arama, kira sözleşmesi hazırlığı ve Anmeldung süreçlerinde sunduğumuz süreç rehberlik hizmetini tanıtmak için ayrılmış kısa bir görüşmedir. Aradığınız konaklama tipini ve ihtiyaçlarınızı dinleyerek, hazırlık desteğimizin nasıl şekillenebileceğini birlikte planlıyoruz.",
    duration: '10 dk.',
  },
  {
    title: 'Kindergarten',
    slogan: 'Kindergarten rehberlik hizmetimiz ile ilgili bilgi alabilmeniz için tanışma görüşmesi.',
    description:
      "Almanya'da Kindergarten, Kita ve Tagesmutter seçenekleri ile kayıt öncesi hazırlık başlıklarında sunduğumuz rehberlik hizmetini tanıtmak için ayrılmış kısa bir görüşmedir.",
    duration: '10 dk.',
  },
  {
    title: 'Üniversite',
    slogan: 'Üniversite rehberlik hizmetimiz ile ilgili bilgi alabilmeniz için tanışma görüşmesi.',
    description:
      "Almanya'da üniversite araştırması, başvuru belgeleri ve kayıt öncesi planlama başlıklarında sunduğumuz rehberlik hizmetini tanıtmak için ayrılmış kısa bir görüşmedir.",
    duration: '10 dk.',
  },
  {
    title: 'Entegrasyon',
    slogan: 'Entegrasyon rehberlik hizmetimiz ile ilgili bilgi alabilmeniz için tanışma görüşmesi.',
    description:
      "Almanya'daki günlük yaşam, dil ve entegrasyon kursları, ulaşım ve ilk dönem uyum başlıklarında sunduğumuz deneyime dayalı rehberlik hizmetini tanıtmak için ayrılmış kısa bir görüşmedir.",
    duration: '10 dk.',
  },
];

const serviceOrder = [
  'Göç Rehberliği Ön Görüşmesi',
  'Vize İşlemleri',
  'Oturum İşlemleri',
  'Daire Kiralama',
  'Kindergarten',
  'Üniversite',
  'Entegrasyon',
  'Banka Hesap Açılışı',
  'Sağlık Sigorta Başvurusu',
];

const orderedServices = [...services].sort(
  (first, second) => serviceOrder.indexOf(first.title) - serviceOrder.indexOf(second.title),
);

// WhatsApp: footer'daki numara (+49 15228301212), pre-fill ile mesaj kutusuna
// kullanıcı hangi hizmeti seçtiyse onu otomatik koyuyoruz.
const WHATSAPP_NUMBER = '4915228301212';
const buildWhatsAppLink = (serviceTitle: string) => {
  const message = `Merhaba, "${serviceTitle}" için randevu almak istiyorum.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

const RandevuPage: React.FC = () => {
  const [expanded, setExpanded] = useState<Record<number, boolean>>({});

  const toggleExpand = (index: number) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="randevu-page-new">
      <section className="randevu-hero">
        <div className="container">
          <h1 className="randevu-hero-title">Randevu Alın</h1>
          <div className="randevu-hero-text">
            <p>
              Size uygun görüşme türünü seçerek WhatsApp üzerinden randevu talebinizi
              iletebilirsiniz.
            </p>
            <p>
              Talebinizin ardından uygun gün ve saat karşılıklı olarak kesinleştirilir ve online
              görüşme bilgileri sizinle paylaşılır.
            </p>
          </div>

          <section className="randevu-process" aria-labelledby="randevu-process-title">
            <h2 id="randevu-process-title">Randevu süreci</h2>
            <ol>
              <li>İhtiyacınıza uygun görüşme türünü seçin.</li>
              <li>WhatsApp üzerinden randevu talebinizi gönderin.</li>
              <li>Uygun gün ve saat birlikte kesinleştirilsin.</li>
              <li>Belirlenen zamanda online görüşmeye katılın.</li>
              <li>
                Görüşme sonrasında uygun bir destek hizmeti bulunuyorsa kapsam ve sonraki adımlar
                ayrıca paylaşılır.
              </li>
            </ol>
          </section>

          <div className="randevu-cards">
            {orderedServices.map((service, index) => {
              const isOpen = !!expanded[index];
              return (
                <div className="randevu-card" key={index}>
                  <h2 className="randevu-card-title">{service.title}</h2>
                  {service.slogan && (
                    <p className="randevu-card-slogan">{service.slogan}</p>
                  )}
                  {service.description && (
                    <>
                      <button
                        type="button"
                        className="randevu-card-details"
                        onClick={() => toggleExpand(index)}
                        aria-expanded={isOpen}
                        aria-controls={`randevu-details-${index}`}
                      >
                        {isOpen ? 'Daha Az Bilgi' : 'Daha Fazla Bilgi'}
                      </button>
                      {isOpen && (
                        <p id={`randevu-details-${index}`} className="randevu-card-description">{service.description}</p>
                      )}
                    </>
                  )}
                  <div className="randevu-card-summary" aria-label="Görüşme bilgileri">
                    <span className="randevu-card-summary-item">
                      <small>Süre</small>
                      <strong>{service.duration}</strong>
                    </span>
                    <span className="randevu-card-summary-item randevu-card-summary-price">
                      <small>Ücret</small>
                      <strong>{service.price || 'Ücretsiz'}</strong>
                    </span>
                  </div>
                  <a
                    href={buildWhatsAppLink(service.title)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="randevu-card-btn"
                  >
                    Randevu Talep Et
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default RandevuPage;
